import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./home.scss";
import axios from "axios";
import SlideInModal from "../../components/slideInModal/SlideInModal";
import CustomerProfile from "../../components/customerProfile/CustomerProfile";

const Customers = () => {
  const [orders, setOrders] = useState([]);
      const [isModalOpen, setIsModalOpen] = useState(false);
       const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  const columns = [
    { field: "status", headerName: "Status", width: 80 },
    { field: "customer", headerName: "Customer", width: 220 },
    { field: "city", headerName: "City", width: 150 },
    { field: "address", headerName: "Address", width: 200 },
    { field: "homeName", headerName: "Home Name", width: 150 },
    { field: "landmark", headerName: "Landmark", width: 150 },
    { field: "phone", headerName: "Phone", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
  ];

  useEffect(() => {
    const getAllOrders = async () => {
      try {
        const response = await axios.get("/get-all-customers");
        const mappedOrders = response.data.map((customer) => ({
          id: customer._id,
          customer: customer.fullName || "",
          city: customer.city || "",
          address: customer.address || "",
          homeName: customer.homeName || "",
          landmark: customer.landmark || "",
          phone: customer.phone || "",
          status: customer.isVerified || "",
          email: customer.email || " ",
        }));

        setOrders(mappedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    getAllOrders();
  }, []);

  return (
    <>
      <div>
        <SlideInModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          {selectedCustomerId && <CustomerProfile cusId={selectedCustomerId} />}
        </SlideInModal>
      </div>
      <div className="main_wrp">
        <div className="main_page_wrp">
          <div className="head_wrp">
            <h5>
              All <em>Customer</em>
            </h5>
          </div>
          <div className="main_body_wrp">
            <DataGrid
              rows={orders}
              columns={columns}
              pageSize={5}
              onCellClick={(params) => {
                setSelectedCustomerId(params.row.id);
                setIsModalOpen(true);
              }}
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              slots={{ toolbar: GridToolbar }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Customers;
